import { cva } from 'class-variance-authority'
import * as React from 'react'
import { cn } from '../../lib/cn'
import type { InputProps } from './input.types'

export const inputVariants = cva(
  [
    'flex w-full',
    'bg-input-background text-input-foreground',
    // Dirty/modified cue (§6.8): a subtle tint when the consumer marks the
    // control `data-modified` (driven per-field, opt-in). The attribute
    // selector outranks the base `bg-input-background`, so it wins when set.
    'data-[modified=true]:bg-input-modified-background',
    'border border-border rounded-(--radius)',
    'px-(--space-md) py-0',
    'text-[16px] md:text-[14px]',
    'placeholder:text-input-placeholder',
    'transition-[background-color,border-color,box-shadow] duration-150',
    'focus-visible:outline-none focus-visible:shadow-(--focus-shadow) focus-visible:border-ring',
    'aria-invalid:border-destructive',
    'disabled:pointer-events-none disabled:opacity-50 disabled:cursor-not-allowed',
    'read-only:cursor-default',
  ].join(' '),
  {
    variants: {
      size: {
        sm: 'h-(--h-input-sm)',
        md: 'h-(--h-input-md)',
        lg: 'h-(--h-input-lg)',
      },
    },
    defaultVariants: { size: 'lg' },
  },
)

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = 'text', size, ...props }, ref) => {
    return (
      <input
        type={type}
        ref={ref}
        className={cn(inputVariants({ size }), className)}
        {...props}
      />
    )
  },
)
Input.displayName = 'Input'

export { Input }
